<template>
  <div class="col-12 relative grey-bg full-height flex flex-column justfity-center items-center">
    <p class="h3n bold center warning m0 mt3">Ressource introuvable</p>
    <Button text="Retour" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="white" icon-left="icon-angle-left-icon" :action="goBack" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { findRouteInformation } from '@/mixins/utils';
import Button from '@/components/elements/Button';

export default {
  components: { Button },
  setup () {
    const route = useRoute();
    const router = useRouter();

    const routeInfo = computed(() => findRouteInformation(route.name));
    const goBack = () => {
      router.replace({ name: routeInfo.value.parentName });
    };
    return { goBack };
  }
};
</script>

<style lang="scss">

</style>
